import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';

import RatePlanList from '~/components/Common/RatePlanList';

import { RATE_PLAN_STATUS_LABELS, getRatePlanStatusGroup } from '~/utils/ratePlanGrouping';

type Props = React.ComponentProps<typeof RatePlanList> & { expandMatches: boolean; groupLabel: string };

export default function RatePlanStatusSections({ expandMatches, groupLabel, ...props }: Props) {
  return (
    <Stack spacing={1}>
      {Object.entries(RATE_PLAN_STATUS_LABELS).map(([status, label]) => {
        const plans = props.ratePlans.filter((plan) => getRatePlanStatusGroup(plan.status) === status);
        if (!plans.length) return null;
        const table = <RatePlanList key={status} {...props} ratePlans={plans} showClassification />;
        if (status === 'active') return table;
        return (
          <Accordion
            key={`${status}-${expandMatches}`}
            defaultExpanded={expandMatches || status === 'unknown'}
            disableGutters
            elevation={0}
            sx={{ '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label={`${groupLabel} ${label.toLowerCase()} rate plans (${plans.length})`}
            >
              <Typography variant="body2" color="text.secondary">
                {label} rate plans ({plans.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pt: 0 }}>{table}</AccordionDetails>
          </Accordion>
        );
      })}
    </Stack>
  );
}
